var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3926 0.619449C12.9969 0.223713 12.3576 0.223713 11.9619 0.619449L7 5.57121L2.03808 0.609302C1.64235 0.213566 1.00308 0.213566 0.607348 0.609302C0.211613 1.00504 0.211613 1.6443 0.607348 2.04004L5.56926 7.00195L0.607348 11.9639C0.211613 12.3596 0.211613 12.9989 0.607348 13.3946C1.00308 13.7903 1.64235 13.7903 2.03808 13.3946L7 8.43268L11.9619 13.3946C12.3576 13.7903 12.9969 13.7903 13.3926 13.3946C13.7884 12.9989 13.7884 12.3596 13.3926 11.9639L8.43073 7.00195L13.3926 2.04004C13.7782 1.65445 13.7782 1.00504 13.3926 0.619449Z",
    fill: "#46766F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCross);
export default __webpack_public_path__ + "static/media/green-cross.90ffa08df84c609091ec8e229e0d18fa.svg";
export { ForwardRef as ReactComponent };